/*
    © 2021 EcomGraduates
*/

// Ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('button[name="add"]')
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    btn.innerHTML = 'Add to cart'

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }

    window.refreshCartContents()
}

// Product Options - listen for onchange events
window.onChangeProductOption = async (input) => {
    const productWrapper = input.closest('.product')
    const addToCartBtn = productWrapper.querySelector('[name="add"]')

    const response = await fetch(`/products/${input.dataset.productHandle}.js`)
    const productData = await response.json()

    const productOptions = []

    productWrapper.querySelectorAll('.product-option').forEach(el => {
        productOptions.push(el.value)
    })

    const selectedVariant = productData.variants.find(variant =>
        variant.title.includes(productOptions.toString().replace(',', ' / '))
    )

    console.log(selectedVariant)

    if (selectedVariant) {
        productWrapper.querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            addToCartBtn.disabled = false
            addToCartBtn.innerHTML = window.themeStrings.addToCart
        } else {
            addToCartBtn.disabled = true
            addToCartBtn.innerHTML = window.themeStrings.soldOut
        }

        if (selectedVariant.compare_at_price) {
            productWrapper.querySelector('.product-price-compare').style.display = 'inline-block'
            productWrapper.querySelector('.product-price-compare s').textContent = window.formatMoney(selectedVariant.compare_at_price)
            productWrapper.querySelector('.product-price-final').classList.add('text-success')
            productWrapper.querySelector('.product-price-final').textContent = window.formatMoney(selectedVariant.price)
        } else {
            productWrapper.querySelector('.product-price-compare').style.display = 'none'
            productWrapper.querySelector('.product-price-compare s').textContent = ''
            productWrapper.querySelector('.product-price-final').classList.remove('text-success')
            productWrapper.querySelector('.product-price-final').textContent = window.formatMoney(selectedVariant.price)
        }

        bootstrap.Carousel.getOrCreateInstance('#product-carousel')
            ?.to(selectedVariant.featured_media.position - 1)

        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)
    } else {
        addToCartBtn.disabled = true
        addToCartBtn.innerHTML = window.themeStrings.unavailable
    }
}

// 'Buy it now' buttons
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]').value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

// Recommended products
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('#recommended-products')
    if (recommendedProducts) {
        const { sectionId, baseUrl, productId, limit } = recommendedProducts.dataset
        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`
        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.target.querySelector('#recommended-products').dataset.sectionId
    if (e.detail.sectionId === sectionId) {
        initRecommendedProducts()
    }
})

//
// Bought Together (cross-sells)
//
const initBoughtTogether = () => {
    const section = document.querySelector('#bought-together')

    // Hide section if no cross-sells are avaiable
    if (section.querySelectorAll('.product-list-item').length <= 1) {
        section.style.display = 'none'
        return false
    }

    // Fade image if product is changed checked
    section.querySelectorAll('.form-check-input').forEach((el) => {
        el.addEventListener('change', (e) => {
            if (e.target.checked) {
                section.querySelector(`[data-product-id="${e.target.dataset.productId}"]`).style.opacity = '1'
            } else {
                section.querySelector(`[data-product-id="${e.target.dataset.productId}"]`).style.opacity = '0.25'
            }
            let bundlePrice = 0
            section.querySelectorAll('.form-check-input').forEach((el) => {
                if (el.checked) {
                    bundlePrice += Number(el.dataset.productPrice)
                }
            })
            section.querySelector('#bought-together-atc-btn span').innerText = window.formatMoney(bundlePrice)
        })
    })

    // Handle add to cart
    section.querySelector('#bought-together-atc-btn').addEventListener('click', (e) => {
        const btn = e.target
        const btnInnerHTML = btn.innerHTML
        btn.style.width = btn.offsetWidth + 'px'
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `
        const formData = {
            items: []
        }
        section.querySelectorAll('.form-check-input').forEach((el) => {
            if (el.checked) {
                const variantId = el.closest('.bought-together-list-item').querySelector('select').value
                formData.items.unshift({
                    id: Number(variantId),
                    quantity: 1
                })
            }
        })

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((data) => {
                btn.innerHTML = btnInnerHTML
                btn.blur()
                document.querySelectorAll('.cart-items-count').forEach((el) => {
                    el.textContent = Number(el.textContent) + formData.items.length
                })

                fetch(window.location.href)
                    .then((response) => response.text())
                    .then((data) => {
                        const parser = new DOMParser()
                        const newDocument = parser.parseFromString(data, 'text/html')
                        document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                        const offcanvas = new bootstrap.Offcanvas(document.querySelector('#offcanvas-cart'))
                        offcanvas.show()
                        window.initCartQty()
                    })
            })
    })
}
initBoughtTogether()
